export default {
      id: "ic-vaix-search-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic-vaix-search-usage",
      toString: function () {
        return this.url;
      }
    }